import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { XhrService } from './xhr.service';
import { AuthGuard } from './auth-guard.service';
import { ToastService } from './toast.service';
import { TranslateService } from '@ngx-translate/core';
import { FAuth } from '../auth/shared/fAuth';
import { apiUrl, downloadPath, enDefualt, arDefualt } from '../shared/config';

@Injectable()
export class RootService implements OnInit, OnDestroy {
  advance: boolean = false;
  tables: Array<any> = [];
  lang: string;

  format: {
    date?: string,
    dateC?: string,
    time?: string,
    timeC?: string,
    datetime?: string,
    datetimeC?: string,
    dateM?: string,
    timeM?: string,
    datetimeM: string
  }
  apiUrl = apiUrl;
  downloadPath = downloadPath;
  constructor(private xhrService: XhrService, public toast: ToastService, public authGuard: AuthGuard, private translate: TranslateService) {
    this.lang = window.localStorage.getItem('lang');
    if (!this.lang) {
      this.lang = 'en';
    }
    translate.setDefaultLang(this.lang);
    translate.use(this.lang);
    this.langInit();
  }

  langInit() {
    if (this.lang == 'en') {
      $("html").removeClass("rtl");
      $("html").addClass("ltr");
      this.format = {
        date: enDefualt.date,
        dateC: enDefualt.dateC,
        time: enDefualt.time,
        timeC: enDefualt.timeC,
        datetime: enDefualt.datetime,
        datetimeC: enDefualt.datetimeC,
        dateM: enDefualt.dateM,
        timeM: enDefualt.timeM,
        datetimeM: enDefualt.datetimeM
      }


    } else {
      $("html").removeClass("ltr");
      $("html").addClass("rtl");
      this.format = {
        date: arDefualt.date,
        dateC: arDefualt.dateC,
        time: arDefualt.time,
        timeC: arDefualt.timeC,
        datetime: arDefualt.datetime,
        datetimeC: arDefualt.datetimeC,
        dateM: arDefualt.dateM,
        timeM: arDefualt.timeM,
        datetimeM: arDefualt.datetimeM
      }
    }
  }

  changeLang() {
    if (this.lang == 'en') {
      this.lang = 'ar';
    } else {
      this.lang = 'en';
    }
    this.translate.use(this.lang);
    window.localStorage.setItem("lang", this.lang);
    this.langInit();
  }

  logout() {
    return this.authGuard.logout();
  }
  login(fAuth: FAuth) {
    return this.authGuard.login(fAuth);
  }
  signup(fAuth: FAuth) {
    return this.authGuard.signup(fAuth);
  }
  forgetPassword(fAuth: FAuth) {
    return this.authGuard.forgetPassword(fAuth);
  }
  changePassword(fAuth: FAuth) {
    return this.authGuard.changePassword(fAuth);
  }
  changePasswordI(fAuth: FAuth) {
    return this.authGuard.changePasswordI(fAuth);
  }
  generateHexString(length) {
    var ret = "";
    while (ret.length < length) {
      ret += Math.random().toString(16).substring(2);
    }
    return ret.substring(0, length);
  }
  checkPagePermission(route, page = "_access") {
    var r = route.split(".");

    if (this.authGuard.auth &&
      this.authGuard.auth.role &&
      this.authGuard.auth.role.permission &&
      this.authGuard.auth.role.permission.page &&
      this.authGuard.auth.role.permission.page[r[0]] &&
      this.authGuard.auth.role.permission.page[r[0]][r[1]]) {
      return this.authGuard.auth.role.permission.page[r[0]][r[1]][page]
    }
    return false;
  }
  checkDBPermission(db) {
    var r = db.split(".");

    if (this.authGuard.auth &&
      this.authGuard.auth.role &&
      this.authGuard.auth.role.permission &&
      this.authGuard.auth.role.permission.db &&
      this.authGuard.auth.role.permission.db[r[0]] &&
      this.authGuard.auth.role.permission.db[r[0]][r[1]]) {
      return this.authGuard.auth.role.permission.db[r[0]][r[1]]._access
    }
    return false;
  }
  checkDBDisabled(db, operation) {

    if (operation == 'read' || operation == 'readC') {
      return true;
    }
    var r = db.split(".");

    if (this.authGuard.auth &&
      this.authGuard.auth.role &&
      this.authGuard.auth.role.permission &&
      this.authGuard.auth.role.permission.db &&
      this.authGuard.auth.role.permission.db[r[0]] &&
      this.authGuard.auth.role.permission.db[r[0]][r[1]]) {
      return this.authGuard.auth.role.permission.db[r[0]][r[1]].readonly
    }
    return true;
  }
  ngOnInit() {

  }

  ngOnDestroy() {


  }
}


// WEBPACK FOOTER //
// ./src/app/service/root.service.ts